import React from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'

const Tooltip = ({ id, extraClass, stayOpen, place = 'top' }) => {
    return (
        <ReactTooltip
            key={id}
            id={id}
            className={`tooltipHover ${extraClass ? extraClass : ''}`}
            place={place}
            delayHide={0}
            effect="solid"
            positionStrategy={'fixed'}
        />
    )
}

const DefaultTooltip = ({ id, className }) => (
    <Tooltip extraClass={className} id={id} />
)

const IconTooltip = ({ id, place }) => (
    <Tooltip
        id={id}
        place={place}
        extraClass={'iconTooltip'}
        stayOpen={false}
    />
)

export default DefaultTooltip

export { DefaultTooltip, IconTooltip, Tooltip }
